import { render } from "./TurnGraph.vue?vue&type=template&id=0cc57c30&scoped=true"
import script from "./TurnGraph.vue?vue&type=script&lang=js"
export * from "./TurnGraph.vue?vue&type=script&lang=js"

import "./TurnGraph.vue?vue&type=style&index=0&id=0cc57c30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc57c30"]])

export default __exports__